<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.5 11.3696L15.7174 16.1232C15.4735 16.3672 15.08 16.3672 14.8361 16.1232L13.4066 14.6939M20.5 14.7826C20.5 17.5374 18.2574 19.78 15.5026 19.78C12.7479 19.78 10.5052 17.5374 10.5052 14.7826C10.5052 12.0279 12.7479 9.78522 15.5026 9.78522M8.84348 15.0478L2.9913 15.0478C2.06965 15.0478 1.32609 14.3043 1.32609 13.3826L1.32609 3.38261C1.32609 2.46096 2.06965 1.71739 2.9913 1.71739L16.2826 1.71739C17.2043 1.71739 17.9478 2.46096 17.9478 3.38261V10.0417M7.80443 3.38261C7.92104 3.38261 8.01548 3.47704 8.01548 3.59365C8.01548 3.71027 7.92104 3.8047 7.80443 3.8047C7.68782 3.8047 7.59339 3.71027 7.59339 3.59365C7.59339 3.47704 7.68782 3.38261 7.80443 3.38261ZM5.72287 3.38261C5.83948 3.38261 5.93391 3.47704 5.93391 3.59365C5.93391 3.71027 5.83948 3.8047 5.72287 3.8047C5.60626 3.8047 5.51183 3.71027 5.51183 3.59365C5.51183 3.47704 5.60626 3.38261 5.72287 3.38261ZM3.64131 3.38261C3.75792 3.38261 3.85235 3.47704 3.85235 3.59365C3.85235 3.71027 3.75792 3.8047 3.64131 3.8047C3.5247 3.8047 3.43026 3.71027 3.43026 3.59365C3.43026 3.47704 3.5247 3.38261 3.64131 3.38261ZM13.094 6.36261C13.488 6.44583 13.7931 6.75652 13.8652 7.15052C13.9429 7.54452 13.7763 7.94408 13.4435 8.17148L7.61609 12.1154C7.49948 12.1931 7.35002 12.1931 7.23341 12.1154L5.34002 10.2026C5.29567 10.1638 5.26793 10.1138 5.26793 10.0528C5.26793 9.99183 5.29567 9.94191 5.34002 9.90313L6.17393 9.13817C6.22941 9.1104 6.30149 9.1104 6.35697 9.13817L7.43919 9.78792L8.85461 8.78922L6.25158 7.18113C6.19611 7.13678 6.16281 7.06469 6.16281 6.99261C6.16281 6.92052 6.19611 6.854 6.25158 6.804L6.88463 6.33852C6.95672 6.29974 7.03993 6.29974 7.10645 6.33852L10.7053 7.68148L12.3718 6.53713C12.5827 6.38209 12.8545 6.31557 13.1162 6.36548L13.094 6.36261Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 56,
    color: "#D0A444",
  },
);
</script>
